export enum CalendarViewOptionEnum {
  BELL_SCHEDULES = 'bellSchedule',
  REACTIONS = 'scheduledReaction',
  EVENTS = 'events'
}
